import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/apiClient";
import { Layout } from "@/components/Layout";
import { ProgressBar } from "@/components/ProgressBar";
import { JobStatusBadge } from "@/components/Badges";
import { FileText, ExternalLink, Layers, Loader2 } from "lucide-react";

export default function Reports() {
  const navigate = useNavigate();
  const [projects, setProjects] = useState(null);
  useEffect(() => { api.get("/projects").then((r) => setProjects(r.data)).catch(() => setProjects([])); }, []);

  return (
    <Layout>
      <div className="border-b border-white/10 bg-[#141414]/70 px-8 py-6 backdrop-blur-xl">
        <div className="flex items-center justify-between">
          <div><h1 className="font-heading text-3xl font-bold tracking-tight text-[#f7f3ec]">Reports</h1><p className="mt-1 text-sm text-neutral-500">Open an individual progress report or run all projects together.</p></div>
          <a href="/reports/combined" target="_blank" rel="noreferrer" data-testid="combined-report-btn" className="gold-gradient flex items-center gap-2 rounded-lg px-4 py-2.5 text-sm font-semibold text-[#121212] transition-opacity hover:opacity-90"><Layers className="h-4 w-4" /> Combined Report (All Projects)</a>
        </div>
      </div>
      <div className="p-8">
        <div className="overflow-hidden rounded-xl border border-white/10 bg-[#1a1a1a]">
          <div className="grid grid-cols-12 gap-4 border-b border-white/10 bg-white/[0.03] px-5 py-3 text-xs font-semibold uppercase tracking-wider text-neutral-500">
            <div className="col-span-5">Project / Client</div><div className="col-span-2">Status</div><div className="col-span-3">Progress</div><div className="col-span-2 text-right">Report</div>
          </div>
          {projects === null && <div className="flex justify-center py-16 text-neutral-500"><Loader2 className="h-5 w-5 animate-spin" /></div>}
          {projects?.length === 0 && <div className="py-14 text-center text-sm text-neutral-500">No projects yet.</div>}
          {projects?.map((p) => (
            <div key={p.id} className="grid grid-cols-12 items-center gap-4 border-b border-white/5 px-5 py-4 last:border-0 hover:bg-white/[0.02]">
              <div className="col-span-5"><div className="font-heading text-base font-semibold text-[#f7f3ec]">{p.name}</div><div className="mt-0.5 text-xs text-neutral-500">{p.job_number} · {p.client_name}</div></div>
              <div className="col-span-2"><JobStatusBadge status={p.status} /></div>
              <div className="col-span-3"><ProgressBar value={p.stats?.overall_percent || 0} /></div>
              <div className="col-span-2 flex justify-end gap-2">
                <a href={`/projects/${p.id}/report`} target="_blank" rel="noreferrer" data-testid={`open-report-${p.id}`} className="flex items-center gap-1.5 rounded-lg border border-white/15 px-3 py-1.5 text-xs font-semibold text-neutral-300 hover:bg-white/5"><FileText className="h-3.5 w-3.5" /> Open</a>
                <button onClick={() => navigate(`/projects/${p.id}`)} className="flex items-center gap-1.5 rounded-lg border border-white/15 px-3 py-1.5 text-xs font-semibold text-neutral-300 hover:bg-white/5"><ExternalLink className="h-3.5 w-3.5" /> Manage</button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </Layout>
  );
}
